"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Portal = _interopRequireDefault(require("../internal/Portal"));

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Drawer = function Drawer(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onChange = _ref.onChange,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'right' : _ref$position,
      _ref$showOverlay = _ref.showOverlay,
      showOverlay = _ref$showOverlay === void 0 ? false : _ref$showOverlay,
      styled = _ref.styled,
      classNames = _ref.classNames,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  (0, _hooks.useKeyPressClose)(onChange);
  return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(_styles.Styled.Drawer, {
    isOpen: isOpen,
    position: position,
    $classNames: classNames,
    className: className,
    $styled: styled
  }, children), showOverlay && isOpen && /*#__PURE__*/_react["default"].createElement(_styles.Styled.Overlay, {
    onClick: function onClick() {
      return onChange(false);
    },
    $classNames: classNames,
    $styled: styled
  }));
};

Drawer.displayName = 'Drawer';
Drawer.propTypes = _objectSpread({
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]).isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  position: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
  showOverlay: _propTypes["default"].bool
}, (0, _utils.classNames)(Object.keys(_styles.Styled)));
Drawer.defaultProps = {
  position: 'right',
  showOverlay: false
};
var _default = Drawer;
exports["default"] = _default;